
const TweenLite = require('gsap/TweenLite').TweenLite;

require('gsap/EasePack');
require('gsap/CSSPlugin');

//__________ GSAP Utils __________

function _gsapSetDisplayNone($element) {
    TweenLite.set($element, {display: "none"});
}

function _gsapResetDisplay($element) {
    TweenLite.set($element, {clearProps: "display"});
}

function anim_openDropDown($element, $duration = 0.15, $display = "block") {
    TweenLite.set($element, {
        height:"auto",
        display: $display,
        autoRound: false,
        clearProps: "margin"
    });
    TweenLite.from($element, $duration, {height:0, autoRound: false});
}

function anim_closeDropDown($element, $duration = 0.1) {
    TweenLite.to($element, $duration, {
        height:0,
        margin: 0,
        autoRound: false,
        onComplete: _gsapSetDisplayNone,
        onCompleteParams: [$element]
    });
}

// function anim_heightDiff($element, $heightFrom, $heightTo){
//
// }


//__________ Fades __________

function anim_fadeOutY($element, $duration, $distance) {
    TweenLite.to($element, $duration, {
        y: $distance,
        opacity: 0,
        ease: Power4.easeInOut,
        onComplete: _gsapSetDisplayNone,
        onCompleteParams: [$element]
    });
}

function anim_fadeOutX($element, $duration, $distance) {
    TweenLite.to($element, $duration, {
        x: $distance,
        opacity: 0,
        ease: Power4.easeInOut,
        onComplete: _gsapSetDisplayNone,
        onCompleteParams: [$element]
    });
}

function anim_fadeInX($element, $duration, $distance, $display = "block") {
    TweenLite.set($element, { opacity: 0, display: "none" });
    TweenLite.to($element, $duration, {
        display: $display,
        x: $distance,
        opacity: 1,
        ease: Power4.easeInOut,
    });
}

function anim_fadeInY($element, $duration, $distance, $display = "block") {
    TweenLite.set($element, { opacity: 0, display: "none" });
    TweenLite.to($element, $duration, {
        display: $display,
        y: $distance,
        opacity: 1,
        ease: Power4.easeInOut,
    });
}


//__________ Exports __________

module.exports = {
    setDisplayNone: ($element) => _gsapSetDisplayNone($element),
    resetDisplay: ($element) => _gsapResetDisplay($element),
    anim: {
        openDropDown: ($element, $duration, $display) => anim_openDropDown($element, $duration, $display),
        closeDropDown: ($element, $duration) => anim_closeDropDown($element, $duration),
        fadeOutX: ($element, $duration, $distance) => anim_fadeOutX($element, $duration, $distance),
        fadeOutY: ($element, $duration, $distance) => anim_fadeOutY($element, $duration, $distance),
        fadeInX: ($element, $duration, $distance, $display) => anim_fadeInX($element, $duration, $distance, $display),
        fadeInY: ($element, $duration, $distance, $display) => anim_fadeInY($element, $duration, $distance, $display),
    },
};